import React, { Component } from 'react'
import { apiProcess } from '../../api/api.js'
import { withRouter } from 'react-router-dom'
import mixpanel from 'mixpanel-browser'
import {
  trackReferralsAcceptInviteView,
  trackReferralsAcceptAttempted,
  trackReferralsAcceptSuccess,
} from '../../elements/tracking/referralsTracking.js'
import { makeTitleCase } from '../../../components/utils'

class GetUserInfoFromCode extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      error: false,
      hasUserData: false,
      userData: {},
    }
  }

  componentDidMount() {
    //this.getUserInfoFromCode()
  }

  getUserInfoFromCode = (
    code,
    callback,
    errorcallback,
    handleLoading,
    type,
    saveAsSignUp
  ) => {
    this.setState({ loading: true })

    if (handleLoading) {
      handleLoading()
    }

    const apiURL = 'referrals/' + code

    const data = false

    apiProcess(apiURL, data, 'referrals-landing-page', this.props.description)
      .then(
        function (responseData) {
          const data = responseData
          this.setState({
            loading: false,
            error: false,
            hasUserData: true,
            userData: {
              wasProcessed: data.referral_attached,
              senderFirstName: data.sender_first_name,
              senderProfilePhoto: data.sender_avatar_cloudinary_id,
              acceptFirstName: data.acceptor_first_name,
              acceptProfilePhoto: data.acceptor_avatar_cloudinary_id,
            },
          })

          let entryType = ''
          if (type) {
            entryType = type
          } else {
            entryType = this.props.entryType
          }

          if (data.referral_attached) {
            //success
            trackReferralsAcceptSuccess(
              this.props.shortDescription,
              code,
              entryType,
              responseData
            )
          } else {
            //attempt
            trackReferralsAcceptInviteView(
              this.props.shortDescription,
              code,
              entryType,
              responseData
            )
          }

          if (saveAsSignUp) {
            mixpanel.people.set({
              'Signed Up Through Referral': true,
              'Referral Code at Sign Up': code,
            })
          }

          callback()
        }.bind(this)
      )
      .catch(
        function (responseData) {
          let errorMessage = 'We are having issues right now.'
          if (
            responseData?.errorResponseData?.error_messages[0] === 'Referral already claimed'
          ) {
            errorMessage = responseData?.errorResponseData?.error_messages[0]
          } else {
            errorMessage = "Sorry, " + makeTitleCase(responseData?.errorResponseData?.error_messages[0]) + "."
          }
          this.setState({
            loading: false,
            error: errorMessage,
            hasUserData: false,
            userData: {},
          })
          let entryType = ''
          if (type) {
            entryType = type
          } else {
            entryType = this.props.entryType
          }
          trackReferralsAcceptAttempted(
            this.props.shortDescription,
            entryType,
            code
          )
          errorcallback()
        }.bind(this)
      )
  }
  render() {
    const { loading, error, hasUserData, userData } = this.state
    return (
      <React.Fragment>
        {this.props.render({
          userLoading: loading,
          getUserInfo: this.getUserInfoFromCode,
          userError: error,
          hasUserData: hasUserData,
          userData: userData,
        })}
      </React.Fragment>
    )
  }
}

export default withRouter(GetUserInfoFromCode)

GetUserInfoFromCode.defaultProps = {
  description: 'Get User Info from code.',
  shortDescription: 'missing',
  entryType: 'missing',
}
